module.exports = __webpack_public_path__ + "img/XG60.png";